<template>
  <div class="app-container">
    <div class="navbar-group">
      <el-button type="primary" @click.native="RestartOrder" :disabled="!canWrite">新增</el-button>
      <!-- 选单 -->
      <el-dropdown>
        <el-button type="primary" :disabled="data.Status == 2 || !canWrite">
          单据选择<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown" style="margin-left: 4px">
          <el-dropdown-item class="dropdown-item" @click.native="getOrder1">请购单</el-dropdown-item>
          <el-dropdown-item class="dropdown-item" @click.native="getOrder2">采购需求</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <el-button type="primary" @click.native="getOrder" :disabled="data.Status == 2 || !canWrite">选单</el-button> -->
      <el-button type="primary" @click.native="save" :disabled="(data.Status == 2 && !is_orderUpdateStatus) || !canWrite">保存</el-button>
      <el-button type="primary" @click.native="orderUpdate" :disabled="data.Status != 2 || !canWrite">变更</el-button>
      <el-button type="primary" @click.native="orderDel" :disabled="!isSave || data.Status == 2 || !canWrite">删除</el-button>
      <el-button type="primary" @click.native="orderReview" :disabled="!isSave || !canReview">{{ ReviewName }}</el-button>
      <!-- 联查 -->
      <el-dropdown>
        <el-button type="primary" :disabled="!isSave">
          关联查询<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown" style="margin-left: 4px">
          <el-dropdown-item class="dropdown-item" @click.native="goJump(1)">请购单</el-dropdown-item>
          <el-dropdown-item class="dropdown-item" @click.native="goJump(2)">进货单</el-dropdown-item>
          <el-dropdown-item class="dropdown-item" @click.native="goJump(3)">采购入库单</el-dropdown-item>
          <!-- <el-dropdown-item class="dropdown-item"
            >采购订单情况</el-dropdown-item
          >
          <el-dropdown-item class="dropdown-item"
            >采购需求分析情况</el-dropdown-item
          >
          <el-dropdown-item class="dropdown-item"
            >销售订单情况</el-dropdown-item
          > -->
          <!-- <el-dropdown-item class="dropdown-item">预测单情况</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <el-button type="primary" @click="openPrint" :disabled="!isSave"
        >打印</el-button
      > -->
      <el-button type="primary" @click="onPrint(data)" :disabled="!isSave">打印</el-button>
      <el-button type="primary" @click="openSetField">明细字段</el-button>
    </div>
    <el-form :inline="true" :model="data" :line-form="true" label-width="90px" ref="ruleForm" :rules="rules" status-icon>
      <el-row>
        <!-- 单据日期 -->
        <el-form-item label="单据日期:" prop="DocDate" label-width="90px">
          <span class="not-edit" v-if="ReviewStatus">{{
            $commonJs.toDateString(data.DocDate)
          }}</span>
          <el-date-picker v-else v-model="data.DocDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期" style="width: 190px" :clearable="false"
            @change="(val) => previewNo(val)" />
        </el-form-item>
        <el-form-item label="单据编码:" prop="DocNo" label-width="90px">
          <span v-if="Mode == 0 || ReviewStatus" class="not-edit" style="min-width: 190px">{{ data.DocNo }}</span>
          <el-input v-else v-model="data.DocNo" placeholder="请输入单据编码" style="min-width: 190px" />
        </el-form-item>

        <el-form-item label="供应商:" prop="TradeUnitId" label-width="90px">
          <span class="not-edit" v-if="ReviewStatus">{{
            data.TradeUnitName
          }}</span>

          <!-- <el-select v-else v-model="data.TradeUnitId" filterable style="width: 180px">
            <el-option
              v-for="item in tradeUnitList"
              :key="item.TradeUnitId"
              :value="item.TradeUnitId"
              :label="item.FullName"
              @click.native="setTradeunit(item)"
            ></el-option>
          </el-select> -->
          <el-select v-else v-model="data.TradeUnitId" filterable style="width: 180px" placeholder="请选择供应商单位">
            <div style="
                max-height: 274px;
                overflow: scroll;
                margin-bottom: -17px;
                margin-right: -17px;
              ">
              <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :value="item.TradeUnitId" :label="item.FullName" @click.native="setTradeunit(item)"></el-option>
            </div>
          </el-select>
          <!-- <select-input
            v-else
            placeholder="请选择供应商"
            :label="data.TradeUnitName"
            v-model="data.TradeUnitId"
            @click="openTradeunit"
            @clear="clearTradeUnit"
            :clearable="!isSelect"
            :disabled="isSelect"
          /> -->
        </el-form-item>
        <el-form-item label="付款方式:">
          <template v-if="ReviewStatus">
            <span class="not-edit" v-if="data.PayId === 1">全额定金</span>
            <span class="not-edit" v-if="data.PayId === 2">全额现结</span>
            <span class="not-edit" v-if="data.PayId === 3">限期付款</span>
            <span class="not-edit" v-if="data.PayId === 4">月结</span>
            <span class="not-edit" v-if="data.PayId === 5">其他</span>
          </template>
          <el-select v-else v-model="data.PayId" style="width: 190px">
            <!-- <el-option v-for="item in serviceList" :key="item.id" :value="item.id" :label="item.name"></el-option>
             -->
            <el-option :value="1" label="全额定金" />
            <el-option :value="2" label="全额现结" />
            <el-option :value="3" label="限期付款" />
            <el-option :value="4" label="月结" />
            <el-option :value="5" label="其他" />
          </el-select>
        </el-form-item>
        <el-form-item label="订金金额:">
          <span class="not-edit" v-if="ReviewStatus">{{
            data.RemainAmount
          }}</span>

          <select-input v-else placeholder="请输入订金金额" v-model="data.RemainAmount" @click="openAmount" style="width: 190px" @clear="clear" />
        </el-form-item>
        <!-- 经手人 -->
        <el-form-item label="经手人:" prop="ClerkId" label-width="90px">
          <span class="not-edit" v-if="ReviewStatus">{{ data.ClerkName }}</span>
          <select-input v-else placeholder="请选择经办人" :label="data.ClerkName" v-model="data.ClerkId" @click="openEmp" style="width: 190px" />
        </el-form-item>
        <el-form-item label="金额汇总:" label-width="90px">
          {{ tableAmountSum }}
        </el-form-item>
        <!-- 制单人 -->
        <el-form-item label="制单人:" label-width="90px">
          {{ data.MakeEmpName }}
        </el-form-item>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注:" label-width="90px">
            <span v-if="orderUpdateStatus">{{ data.Remark }}</span>
            <el-input v-else type="textarea" v-model="data.Remark" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="60" placeholder="请填写备注信息" style="width: 600px" />
          </el-form-item>
        </el-col>
      </el-row>
      <!--  -->
      <el-row style="margin: 0px 0 20px">
        <el-table border :data="tableList" class="tableList" :row-class-name="tableRowClassName" @row-click="addColumn" v-keymove="addList">
          <insert-row @on-insert="onInsert" />
          <el-table-column min-width="160" align="left" label="备注" v-if="showField('备注')">
            <template slot-scope="{ row }">
              <span v-if="ReviewStatus">{{ row.Remark }}</span>
              <el-input v-else v-model="row.Remark" @change="editT(row)" placeholder="请输入备注" />
            </template>
          </el-table-column>
          <el-table-column align="left" label="存货名称" min-width="120px" v-if="showField('存货名称')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.ProductName }}</span>
              <account-select v-else v-model="row.ProductName" :source="DAccount" @select="onSelect($event, row, $index)" :pageSize="pageParams.pageSize" :pageIndex="pageParams.pageIndex"
                :listTotal="listTotal" @inputText="inputText($event, row)" @click.native="resetFun" @currentPage="currentPage($event, row)" :pageType="true" />
            </template>
          </el-table-column>
          <el-table-column align="left" label="规格型号" v-if="showField('规格型号')">
            <template slot-scope="{ row }">
              <span>{{ row.ProductSpec }}</span>
            </template>
          </el-table-column>
          <el-table-column width="130" prop="BatchNumber" align="left" label="批号" v-if="showField('批号')" >
             <template slot-scope="{ row, $index }">
              <span v-if="!row.ProductName" style="color:#999;">请先选择存货</span>
              <span v-else-if="!row.IsBatchNumber" class="text-gray">该存货未启用批号</span>
              <span v-else-if="ReviewStatus">{{ row.BatchNumber }}</span>
              <account-select v-else 
                v-model="row.BatchNumber" 
                :Head='Head'
                :source="batchList"
                :listTotal="batchListTotal" :pageType="true" 
                :pageSize="batchPageParams.pageSize" :pageIndex="batchPageParams.pageIndex"
                @select="onSelBatch($event, row, $index)" 
                @inputText="inputTextBatch($event, row)" 
                @click.native="onOpenBatch($event, row, $index)" 
                @currentPage="currentPageBatch($event, row)" 
                keyword="BatchNumber"/>
            </template>
          </el-table-column>
          <el-table-column label="属性" prop="PropertyId" align="left" min-width="100" key="table1_6" v-if="showField('属性')">
            <template slot-scope="{ row }">
              <span v-if="row.SourceDocNo && !row.PropertyId">{{
                row.PropertyName ? row.PropertyName : ""
              }}</span>
              <el-select v-else-if="row.UseProcess" v-model="row.PropertyId" @change="changeProperty($event, row)" :disabled="row.isSource">
                <el-option v-for="item in propertyList" :key="item.PropertyId" :label="item.PropertyName" :value="item.PropertyId"></el-option>
              </el-select>
              <span v-else-if="row.PropertyName" style="text-align: center">{{
                row.PropertyName
              }}</span>
              <span v-else style="text-align: center"></span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="颜色" min-width="120px" v-if="showField('颜色')">
            <template slot-scope="{ row, $index }">
              <span v-if="row.SourceDocNo && !row.ColorId">{{
                row.ColorName ? row.ColorName : ""
              }}</span>
              <el-select v-else-if="row.UseColor && !ReviewStatus" v-model="row.ColorId" @change="changeColor(row, $index)">
                <el-option v-for="item in row.Colors" :key="item.ColorId" :value="item.ColorId" :label="item.ColorName" :disabled="item.Status==0" />
              </el-select>
              <span v-else-if="row.ColorName">{{ row.ColorName }}</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <!--  -->
          <el-table-column align="left" label="采购单位" min-width="80px" v-if="showField('采购单位')">
            <template slot-scope="{ row, $index }">
              <el-select v-if="row.Units && row.Units.length > 0 && !ReviewStatus && row.HasGrammage != true" v-model="row.PuUnitId">
                <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareSaUnit(item, row, $index)"></el-option>
              </el-select>
              <span v-else>{{ row.UnitName }}</span>
            </template>
            <!--  -->
          </el-table-column>
          <!--  -->
          <el-table-column align="right" label="数量" min-width="120px" v-if="showField('数量')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{
                $commonJs.toThousands(row.PurchaseQuantity)
              }}</span>
              <el-input v-else type="text" v-model="row.PurchaseQuantity" @change="changeQuantity($event, row, $index)"></el-input>
            </template>
          </el-table-column>
          <!--  -->
          <el-table-column align="right" label="报价" min-width="100px" v-if="canPrice&&showField('报价')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.Offer }}</span>
              <el-input v-else v-price type="text" v-model="row.Offer" :disabled="row.IsGift" @change="changeOffer(row, $index)">
              </el-input>
            </template>
          </el-table-column>
          <!--  -->
          <el-table-column align="right" label="金额" min-width="100px" v-if="canPrice&&showField('金额')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{
                $commonJs.toThousands(row.Amount)
              }}</span>
              <el-input v-else v-decimals type="text" v-model="row.Amount" :disabled="row.IsGift" @input="changeAmount(row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="可用量" v-if="showField('可用量')">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.ExistQuantity) ) }}</span>
            </template>
          </el-table-column>
          <!--  -->
          <el-table-column align="right" label="现存量" v-if="showField('现存量')">
            <template slot-scope="{ row }">
              <!-- <span>{{ row.StockQuantity }}</span> -->
              <span>{{ $commonJs.toThousands(getQuantity(row.StockQuantity) ) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="条形码" min-width="140px" v-if="showField('条形码')">
            <template slot-scope="{ row }">
              <!-- <span>{{ row.name }}</span> -->
              <vue-barcode :value="row.ProductNo" width="1" height="20" fontSize="10"></vue-barcode>
            </template>
          </el-table-column>
          <!--  -->
          <el-table-column align="left" label="存货编码" min-width="140px" v-if="showField('存货编码')">
            <template slot-scope="{ row }">
              <span>{{ row.ProductNo }}</span>
            </template>
          </el-table-column>
          <!--  -->
          <el-table-column align="left" label="计量单位2" min-width="100px" v-if="showField('计量单位2')">
            <template slot-scope="{ row, $index }">
              <!-- <span>{{ row }}{{ $index }}</span> -->
              <el-select v-if="row.Units && row.Units.length > 0 && !ReviewStatus && row.HasGrammage != true" v-model="row.UnitId2">
                <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareUnitId(item, row, $index)"></el-option>
              </el-select>
              <span v-else-if="row.UnitType == 0"></span>
              <span v-else>{{ row.Unit2Name }}</span>
            </template>
          </el-table-column>
          <!--  -->
          <el-table-column align="right" label="数量2" v-if="showField('数量2')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{
                $commonJs.toThousands(row.Quantity2)
              }}</span>
              <span v-else-if="row.UnitType == 0"></span>
              <el-input v-else type="text" v-model.number="row.Quantity2" @change="changeQuantity2($event, row, $index)" @blur="getChangeQuantity($event, row, $index)" />
            </template>
          </el-table-column>
          <el-table-column align="right" label="换算率" v-if="showField('换算率')">
            <template slot-scope="{ row, $index }">
              <span v-if="
                  (ReviewStatus || row.ChangeType == 0) && row.UnitType == 1
                ">{{ row.Rate }}</span>
              <span v-else-if="row.UnitType == 0"></span>
              <el-input v-else type="text" v-model="row.Rate" @input="RateChange($event, row, $index)"></el-input>
            </template>
          </el-table-column>

          <el-table-column align="right" label="折扣%" min-width="100px" v-if="canPrice&&showField('折扣%')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.Discount }}</span>
              <el-input v-else v-decimals type="text" v-model="row.Discount" :disabled="row.IsGift" @input="changeDiscount(row, $index)" />
            </template>
          </el-table-column>
          <el-table-column align="right" label="税率%" min-width="100px" v-if="canPrice&&showField('税率%')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.TaxRate }}</span>
              <el-input v-else v-decimals v-limit:value="{ max: 100, min: 0 }" type="text" v-model.number="row.TaxRate" :disabled="row.IsGift"
                @input="changeTaxRate(row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="单价" min-width="140px" v-if="canPrice&&showField('单价')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.Price }}</span>
              <el-input v-else v-price type="text" v-model="row.Price" :disabled="row.IsGift" @change="changePrice(row, $index)">
                <el-button v-if="row.ProductName" slot="append" @click="openSales(row, $index)" icon="el-icon-s-order"></el-button>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="含税单价" min-width="100px" v-if="canPrice&&showField('含税单价')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.TaxPrice }}</span>
              <el-input v-else v-price type="text" v-model.number="row.TaxPrice" :disabled="row.IsGift" @input="changeTaxPrice(row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="税额" min-width="100px" v-if="canPrice&&showField('税额')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{
                $commonJs.toThousands(row.TaxLimit)
              }}</span>
              <el-input v-else v-decimals type="text" v-model="row.TaxLimit" :disabled="row.IsGift" @input="changeTaxLimit(row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="含税金额" min-width="100px" v-if="canPrice&&showField('含税金额')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{
                $commonJs.toThousands(row.TaxAmount)
              }}</span>
              <el-input v-else v-decimals type="text" v-model="row.TaxAmount" :disabled="row.IsGift" @input="changeTaxAmount(row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="折扣金额" min-width="100px" v-if="canPrice&&showField('折扣金额')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{
                $commonJs.toThousands(row.DiscountAmount)
              }}</span>
              <el-input v-else v-decimals type="text" v-model="row.DiscountAmount" :disabled="row.IsGift" @input="changeDiscountAmount(row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="left" label="预计到货日期" min-width="180px" v-if="showField('预计到货日期')">
            <template slot-scope="{ row }">
              <span v-if="ReviewStatus">{{
                $commonJs.toDateString(row.DeliveryDate)
              }}</span>
              <el-date-picker v-else v-model="row.DeliveryDate" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 140px"
                @change="changeDeliveryDate(row)">
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column align="center" label="赠品" v-if="showField('赠品')">
            <template slot-scope="{ row }">
              <el-checkbox @change="changeIsGift($event, row)" v-model="row.IsGift" :disabled="ReviewStatus"></el-checkbox>
            </template>
          </el-table-column>

          <el-table-column align="center" label="行中止" v-if="showField('行中止')">
            <template slot-scope="{ row }">
              <el-checkbox v-model="row.LineAbort" @change="changeLineAbort($event, row)" :disabled="isLineAbort || orderUpdateStatus" true-label="1" false-label="0"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column align="left" label="中止人" v-if="showField('中止人')">
            <template slot-scope="{ row }">
              <span>{{ row.LineAbortEmpName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="中止时间" min-width="100px" v-if="showField('中止时间')">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toDateString(row.LineAbortDate) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="累计执行数量" min-width="120px" v-if="showField('累计执行数量')">
            <template slot-scope="{ row }">
              <span>{{$commonJs.toThousands(getQuantity(row.ExecutionQuantity)) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="累计执行数量2" min-width="130px" v-if="showField('累计执行数量2')">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity( row.ExecutionQuantity2))}}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="销售订单号" min-width="120px" v-if="showField('销售订单号')">
            <template slot-scope="{ row }">
              <span>{{ row.SaOrderNo }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="价格策略类型" min-width="130px" v-if="showField('价格策略类型')">
            <template slot-scope="{ row }">
              <span v-if="row.PriceType == 0">进货价</span>
              <!-- <span v-if="row.PriceType == 1">进价带出策略</span> -->
            </template>
          </el-table-column>
          <el-table-column prop="SourceTypeName" align="left" label="来源单据" v-if="showField('来源单据')" />
            <!-- <template slot-scope="{ row }">
              <span v-if="row.SourceType === 6">销售订单</span>
              <span v-if="row.SourceType === 1">请购单</span>
            </template>
          </el-table-column> -->
          <el-table-column align="left" label="来源单号" min-width="180px" v-if="showField('来源单号')">
            <template slot-scope="{ row }">
              <span>{{ row.SourceDocNo }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" v-if="!ReviewStatus">
            <template slot-scope="{ row, $index }">
              <el-button v-if="$permission.canWrite('/business/purchase/emptor')" type="text" @click.stop="delTableList(row, $index)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <!--  -->
      <el-row>
        <el-form-item label="审核人:" label-width="80px" style="width: 190px">
          {{ data.ReviewEmpName }}
        </el-form-item>
        <el-form-item label="审核时间:" label-width="80px" style="width: 190px">
          {{ $commonJs.toDateString(data.ReviewDate) }}
        </el-form-item>
        <el-form-item label="变更人:" label-width="80px" style="width: 190px">
          {{ data.UpdateUserName }}
        </el-form-item>
        <el-form-item label="变更日期:" label-width="80px" style="width: 190px">
          {{ $commonJs.toDateString(data.UpdateTime) }}
        </el-form-item>
      </el-row>
    </el-form>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <order-dialog ref="orderDialog" @save="initerPrice" in-dialog />

    <inquiry-select ref="inquirySelect" in-dialog selectable multiple :TradeUnitId="data.TradeUnitId" @select-multiple="setOrderList" />
    <newdemand-select ref="newdemandSelect" in-dialog selectable multiple :TradeUnitId="data.TradeUnitId" @select-multiple="setOrderList" />
    <print-dialog ref="printDialog" :columns="columns" :data="columnData" :form-data="formData"></print-dialog>
    <tradeunit-dialog ref="tradeunitDialog" in-dialog selectable @select="setTradeunit" />
    <amount-dialog ref="editDialog" @data="setPayData" @close-saved="reload" />
    <field-dialog ref="fieldDialog" @close-saved="setTbField" />
  </div>
</template>
<script>
import VueBarcode from "vue-barcode";
import curdMixins from "@/mixins/trend/curd";
import empDialog from "@/components/personnel/result/record/listDialog";
import orderDialog from "@/components/business/purchase/emptor/priceDialog";
import printDialog from "@/components/common/printDialog/printDialog";
import accountSelect from "@/components/business/purchase/select";
// import saleOrderSelect from "@/components/business/sales/saleorder/listDialog";
// import deliveryReleaseSelect from "@/components/business/sales/deliveryrelease/info/listDialog";
// import list from "@/components/business/purchase/inquiry/list";
import saleList from "@/data/business/sales/sale/edit/list.json";
import optionMixins from "@/mixins/option";

// import settle from "@/components/basedata/finance/settle/select";
// import invoiceSelect from "@/components/basedata/finance/invoice/select";
// import wmsSelect from "@/components/basedata/basedoc/wms/select";
// import businessSelect from "@/components/basedata/basedoc/business/select";

import inquirySelect from "@/components/business/purchase/inquiry/listDialog";
import newdemandSelect from "@/views/business/purchase/emptor/editEmptor/newdemandSelect/listDialog";
import tradeunitDialog from "@/components/basedata/business/come/listDialog";
import amountDialog from "@/components/business/purchase/emptor/editDialog";
import fieldDialog from "@/components/common/fieldDialog"
export default {
  name: "editEmptor",
  mixins: [curdMixins, optionMixins],
  components: {
    // list,
    empDialog,
    orderDialog,
    accountSelect,
    VueBarcode,
    printDialog,
    amountDialog,
    inquirySelect,
    newdemandSelect,
    tradeunitDialog,
    fieldDialog
  },
  data() {
    return {
      propertyList: [],
      propertyApi: require("@/api/ba/property").default,
      api: require("@/api/pu/puOrder").default,
      sourceTypeApi: require("@/api/ba/sourceType").default,
      pdApi: require("@/api/ba/product").default,
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      transportApi: require("@/api/ba/transport").default,
      code_api: require("@/api/sy/serialCode").default,
      docSetting_api: require('@/api/sy/docSetting').default,
      initDAccount: [],
      deleteDateList: [],
      initTotal: 0,
      formData: [],
      columnkey: [],
      columns: [],
      columnData: [],
      tableColorShow: true,
      colorList: [],
      DAccount: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      isSelect: false, // 是否有选单的操作
      data: {
        OrderId: 0,
        SaOrderId: 0,
        DocNo: "",
        DocDate: this.$commonJs.getToday(),
        TradeUnitId: null,
        TradeUnitName: "",
        PayId: null,
        ClerkId: 0,
        PayWay: null,
        DeliveryDate: "",
        Remark: "",
        Amount: 0,
        NoTaxAmount: 0,
        TaxAmount: 0,
        PayAmount: 0,
        RemainAmount: null,
        DisposeTax: 0,
        Status: 0,
        InStatus: 0,
        CompleteStatus: 0,
        PayStatus: 0,
        // AddTime: "2022-10-19T07:23:22.555Z",
        // UpdateTime: "2022-10-19T07:23:22.555Z",
        // AddUserId: 0,
        // UpdateUserId: 0,
        PredictId: null,
        ClerkId: null,
        MakeEmpId: null,
        MakeDate: "",
        ReviewEmpId: null,
        ReviewDate: "",
        ClerkName: "",
        ReviewEmpName: "",
        MakeEmpName: "",
        Products: [],
        Pays: [],
      },
      isMainUnitId2: false,
      Mode: 0,
      isSave: false,
      tabPosition: "",
      reach: "联查",
      handledBy: "",
      preparedBy: "",
      IsGift: false,
      service: null,
      is_orderUpdateStatus: false,
      productList: [],
      tradeUnitList: [],
      transportList: [],
      tableList: [],
      optionList: [],
      currentRow: null,
      currentIndex: 0,
      rules: {
        DocDate: [
          { required: true, message: "单据日期不能为空", trigger: "blur" },
        ],
        DocNo: [
          { required: true, message: "单据编码不能为空", trigger: "blur" },
        ],
        TradeUnitId: [
          { required: true, message: "客户不能为空", trigger: "change" },
        ],
        Address: [
          { required: true, message: "送货地址不能为空", trigger: "blur" },
        ],
        TransportId: [
          { required: true, message: "运输方式不能为空", trigger: "blur" },
        ],
        ClerkId: [
          { required: true, message: "经手人不能为空", trigger: "blur" },
        ],
        Remark: [{ required: true, message: "备注不能为空", trigger: "blur" }],
      },
      option: {
        // 换算率
        Iinvexchrate: 0,
        //数量
        PurchaseQuantity: 0,
        //数量舍零
        IsQuantityRounding: true,
        // 单价整数
        UnitPrice: 0,
        // 单价小数
        UnitPriceDecimals: 0,
        // 单价舍零
        IsUnitPriceRounding: true,
      },
      detailFields: [],
      showDetail: false,
      Head:[
        { Value: "BatchNumber", Name: "批号", Width: "180" },
        { Value: "WarehouseName", Name: "仓库", Width: "100" },
        { Value: "ColorName", Name: "颜色", Width: "80" },
        { Value: "PropertyName", Name: "属性", Width: "80" },
        // { Value: "BatchStartDate", Name: "批次起始日期", Width: "100" },
        // { Value: "ExpireDate", Name: "有效期至", Width: "100" },
        { Value: "BaseUnitName", Name: "主单位", Width: "80" }, 
        { Value: "BaseQuantity", Name: "现存量", Width: "80" }
      ],
      batchListTotal:0,
      batchPageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      batchList:[]
    };
  },
  computed: {
    tableAmountSum() {
      let sum = 0;
      let length = this.tableList.length;
      for (let i = 0; i < length; ++i) {
        sum = sum + parseFloat(this.tableList[i]?.Amount ?? 0);
      }
      sum = sum.toFixed(2);
      sum = this.$commonJs.toThousands(sum)
      return sum;
    },
    PayWayName() {
      switch (this.data.PayWay) {
        case 1:
          return "全额定金";
        case 2:
          return "全额现结";
        case 3:
          return "限期付款";
        case 4:
          return "月结";
        case 5:
          return "其他";
      }
    },
    orderUpdateStatus() {
      return this.data.Status == 2 && !this.is_orderUpdateStatus ? true : false;
    },
    ReviewName() {
      return this.data.Status == 2 ? "弃审" : "审核";
    },
    isLineAbort() {
      return this.data.OrderId > 0 && this.data.Products.length > 0
        ? false
        : true;
    },
    ReviewStatus() {
      return this.data.Status == 2 ? true : false;
    },
    canPrice() {
      return this.$permission.canPrice("/business/purchase/emptor");
    },
    canWrite() {
      return this.$permission.canWrite("/business/purchase/emptor");
    },
    canReview() {
      return this.$permission.canReview("/business/purchase/emptor");
    },
  },

  mounted() {
    this.init();
    // this.api.list({}).then((res) => (this.productList = res.Data));
    if (this.$route.params.isSave) this.isSave = true;
    if (this.$route.params.mode == "create" || !this.$route.params.mode) {
      this.createOrder();
    }
    if (this.$route.params.mode == "edit") {
      this.editOrder(this.$route.params.data.OrderId);
    }
    if (this.$route.params.mode == "details") {
      this.editOrder(this.$route.params.data.OrderId);
    }
  },
  methods: {
    openSetField() {
      this.$refs.fieldDialog.open().then(that => {
        that.getData({ DocType: "采购订单", Url: "business/purchase/emptor/edit" });
      })
    },
    setTbField() {
      this.showDetail = false;
      this.docSetting_api.list({ DocType: "采购订单", IsShow: true }).then(res => {
        if (res.Code == 0) {
          this.detailFields = res.Data.map(x => x.FormKey);
          this.$nextTick(() => {
            this.showDetail = true;
          })
        }
      })
    },
    showField(type) {
      return this.detailFields.indexOf(type) != -1;
    },
    async goJump(index) {
      let params = {};
      let ids = [];
      switch (index) {
        case 1: //联查请购单，查询采购订单引用请购单的商品所属的SourceDocId
          // params.SourceType=1
          const res = await this.sourceTypeApi.info("请购单");
          ids = this.data.Products.filter((item) => {
            return item.SourceType === res.SourceTypeId;
          }).map((item) => {
            return item.SourceDocId;
          });
          if (ids.length === 0) {
            this.$message.error("单据未引用请购单，无法进行联查");
          } else {
            params.Ids = ids;
            params.SourceType = res.SourceTypeId;
            this.$router.push({ name: "inquiry", params: params });
          }

          break;
        case 2:
          params.SourceDocId = this.data.OrderId;
          const res2 = await this.sourceTypeApi.info("采购订单");
          params.SourceType = res2.SourceTypeId;
          this.$router.push({ name: "stock", params: params });
          break;
        case 3:
          params.SourceDocId = this.data.OrderId;
          const res3 = await this.sourceTypeApi.info("采购订单");
          params.SourceType = res3.SourceTypeId;
          // params.SourceType=1
          this.$router.push({ name: "purchaseinbound", params: params });
          break;
      }
    },
    initerPrice(price) {
      this.currentRow.Price = price;
      this.changePrice(this.currentRow, this.currentIndex);
    },
    clear() {
      let deleteDateList = this.data.Pays.filter((item) => {
        return item.T !== 0;
      });

      deleteDateList.forEach((item) => {
        item.T = 2;
      });
      this.setPayData([], deleteDateList);
    },
    onInsert(e) {
      let { type, index } = e;

      this.interpolate(null, index, type);
    },
    interpolate(row, index, type = "") {
      let o = {
        T: 0,
        OrderProductId: 0,
        // OrderId: 0,
        ColorId: null,
        ColorName: "",
        BarCode: "",
        ExistQuantity: 0,
        ProductId: 0,
        Offer: 0,
        Discount: 0,
        NoTaxPrice: 0,
        TaxRate: 0,
        Price: 0,
        BatchNo: "",
        NoTaxAmount: 0,
        TaxAmount: 0,
        Amount: 0,
        PackQuantity: 0,
        InQuantity: 0,
        UnitId2: 0,
        Quantity2: 0,
        LineAbortEmpId: 0,
        LineAbortDate: "",
        LineAbort: 0,
        IsGift: false,
        LineAbortEmpName: "",
        UnitName: "",
        Unit2Name: "",
        SourceType: 0,
        SourceOrderId: 0,
        SourceDtsId: 0,

        SourceTypeName: "",
        PuUnitId: 0,
        PurchaseQuantity: 0,
        DeliveryDate: "",
        Rate: 0,
        DiscountAmount: 0,
        ProductNo: "",
        ProductSpec: "",
        ProductName: "",
        ExecutionQuantity: 0,
        ExecutionQuantity2: 0,
        PriceType: null,
        SourceType: 0,
        SourceDocNo: "",
        StockQuantity: 0,
        ExistQuantity: 0,
      };
      if (type == "down") {
        index = index + 1;
      }
      this.tableList.splice(index, 0, o);
      let copy = JSON.parse(JSON.stringify(this.tableList));
      this.tableList = [];
      this.$nextTick(() => {
        this.tableList = copy;
      });
    },
    setPayData(data, deleteDateList) {
      this.data.Pays = data;
      this.deleteDateList.push(...deleteDateList);
      this.data.RemainAmount = data
        .map((i) => i.PayAmount)
        .reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
      // this.data.RemainAmount = 30;

      console.log("Amount", this.data.RemainAmount);
    },
    openAmount() {
      this.$refs.editDialog.open();
    },
    openTradeunit() {
      if (!this.isSelect) {
        this.$refs.tradeunitDialog.open().then((that) => {
          that.getData({ TradeUnitTypes: [1, 2], Status: 1 });
          // that.getData();
        });
      }
    },
    clearTradeUnit() {
      this.data.TradeUnitId = null;
      this.data.TradeUnitName = "";
    },
    async getOrder1() {
      const res = await this.sourceTypeApi.info("采购订单");
      let OrderType = res.SourceTypeId;

      let that = await this.$refs.inquirySelect.open();
      that.getData({
        Status: 2,
        TradeUnitId: this.data.TradeUnitId,
        LineAbort: false,
        OrderType,
      });
    },
    async getOrder2() {
      const res = await this.sourceTypeApi.info("采购订单");
      let OrderType = res.SourceTypeId;

      let that = await this.$refs.newdemandSelect.open();
      that.getData({
        // Status: 2,
        // TradeUnitId: this.data.TradeUnitId,
        // LineAbort: false,
        OrderType,
      });
    },
    previewNo(val = "") {
      this.code_api.previewNo("采购订单", val).then((res) => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取采购订单编码失败");
        }
      });
    },
    // 属性切换
    changeProperty(val, row) {
      if (row.T !== 0) {
        row.T = 1;
      }

      let item = this.propertyList.filter((item) => {
        return item.PropertyId === val;
      })[0];

      row.PropertyName = item.PropertyName;
      var pm = { ProductId: row.ProductId, PropertyId: row.PropertyId };
      if (row.ColorId) {
        pm.ColorId = row.ColorId;
      }
      this.pdApi.stockInfo(pm).then((res) => {
        if (res.Code == 0) {
          row.ExistQuantity = res.Data.AvailableQuantity;
          row.StockQuantity = res.Data.StockQuantity;
        }
      });
    },
    init() {
      this.propertyApi
        .list({
          Status: 1,
        })
        .then((res) => {
          if (res.Code === 0) {
            this.propertyList = res.Data;
          }
        });
      this.callOptionApi();
      this.tradeUnitApi
        .list({ TradeUnitTypes: [1, 2, 3], Status: 1 })
        .then((res) => {
          if (res.Code == 0) this.tradeUnitList = res.Data;
        });
      this.transportApi.list({}).then((res) => {
        if (res.Code == 0) this.transportList = res.Data;
      });
      this.pdApi
        .list({ Property: "采购", Status: 1, pageIndex: 1, pageSize: 7 })
        .then((res) => {
          this.DAccount = res.Data;
          this.initDAccount = res.Data;
          this.listTotal = res.Count;
          this.initTotal = res.Count;
        });
      this.setTbField();
    },
    createOrder() {
      const user = this.$store.state.user;
      if (user) {
        this.data.ClerkId = user.empId;
        this.data.ClerkName = user.name;
        this.data.MakeEmpId = user.id;
        this.data.MakeEmpName = user.name;
      }
      this.addList();
      this.previewNo();
    },
    editOrder(data, type = 0) {
      console.log("执行编辑", data);
      this.api.info(data).then((res) => {
        if (res.Code === 0) {
          this.isSave = true;
          this.data = res.Data;
          this.data.Pays = res.Data.Pays?.map((i) => ((i.T = null), i));
          this.tableList = res.Data.Products?.map(
            (item) => ((item.T = 3), item)
          );
          this.tableList.forEach((item) => {
            if (item.Units.length === 0) {
              item.UnitType = 0;
            } else {
              item.UnitType = 1;
              let UnitItem = item.Units.filter((v) => {
                return item.PuUnitId === v.UnitId;
              })[0];
              console.log("UnitItem", UnitItem);

              item.IsMain = UnitItem.IsMain;
              item.ChangeType = 0;
              item.Units.forEach((v) => {
                if (v.ChangeType == 1) item.ChangeType = v.ChangeType;
              });
            }
          });

          if (res.Data.Products.length == 0) this.addList();

          if (type === 1) {
            this.Review();
          }
        }
      });
    },
    editT(row) {
      if (row.T !== 0) {
        row.T = 1;
      }
    },
    toggleOrder() {
      this.$refs.saleQuotationSelect.open();
    },
    async setOrderList(data) {
      console.log("data", data);

      // let TradeUnitIds = data.List.map(item => {
      //   return item.TradeUnitId;
      // })

      // TradeUnitIds = Array.from(new Set(TradeUnitIds));
      // if(TradeUnitIds.length === 1){
      //   this.data.TradeUnitId = data.List[0].TradeUnitId;
      //   this.data.TradeUnitName = data.List[0].TradeUnitName;
      // }

      if (data.List[0].TradeUnitId) {
        this.data.TradeUnitId = data.List[0].TradeUnitId;
        this.data.TradeUnitName = data.List[0].TradeUnitName;
      }

      let Quantity = this.tableList.map((i) => i.ProductId);

      const res = await this.sourceTypeApi.info("采购需求");
      let SourceType = res.SourceTypeId;
      // data.List[0].SourceType==''? SourceType=1 :SourceType=6

      let addList = [];
      addList = data.List.reduce((arr, item) => {
        if (!Quantity.includes(item.ProductId)) {
          // let UnitType = 0;
          // let ChangeType = 1;
          // if (item.Units.length != 0) {
          //   UnitType = 1;
          // }
          // if (item.Units.length > 0 && item.UnitId) {
          //   const firstIndex = item.Units.findIndex(e => e.UnitId === item.UnitId)
          //   const secondIndex = item.Units.findIndex(e => e.IsMain == false)
          //   const IsMainIndex = item.Units.findIndex(e => e.IsMain)
          //   if (firstIndex === IsMainIndex) {
          //     ChangeType = item.Units[secondIndex].ChangeType
          //     item.IsMain=true
          //   } else {
          //     ChangeType = item.Units[firstIndex].ChangeType
          //     item.IsMain=false
          //   }
          // } else {
          //   item.Units.forEach(v=>{
          //     if(v.ChangeType==1)item.ChangeType=v.ChangeType
          //   })
          // }
          arr.push({
            StockQuantity: 0,
            ExistQuantity: 0,
            Requirement: "",
            ...item,
            SourceType,
            // SourceDtsId:item.
            SourceDocId: item.OrderProductId,
            SourceDtsId: item.WorkDocMaterialId,
            SourceDocNo: item.DemandNo,
            OrderProductId: 0,
            PurchaseQuantity: item.Quantity,
            PuUnitId: item.PuUnitId,
            UnitName: item.PuUnitName,
            BaseQuantity: item.BaseQuantity ?? 0,
            DpName: item.DpName ?? "",
            PropertyId: item.PropertyId ?? 0,
            PropertyName: item.PropertyName ?? "",
            SubQuantity: item.SubQuantity ?? 0,
            LineAbortDate: item.LineAbortDate == 0 ? "" : item.LineAbortDate,
          });
        } else {
          this.$message.warning("该产品已存在");
        }
        return arr;
      }, []);
      addList.forEach((item, i) => {
        item.UnitType = 0;
        item.ChangeType = 0;

        if (item.Units.length === 0) {
          item.Quantity2 = 0;
          item.Price2 = 0;
        } else {
          item.UnitType = 1;
          let index = this.getUnitIndex(3, item.Units, item.PuUnitId);
          console.log("index", index);
          let data = this.getUnitValue(item.Units, index);
          console.log("data", data);
          let assistIndex = 0;
          let assistData = {};
          item.IsMain = data.IsMain;
          item.UnitName=data.UnitName;
          // row.ChangeType1 = data.ChangeType;
          item.Units.forEach((item2) => {
            if (item2.ChangeType == 1) item.ChangeType = item2.ChangeType;
          });
          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, item.Units);
            assistData = this.getUnitValue(item.Units, assistIndex);
            item.Rate = parseFloat(this.getIinvexchrate(assistData.Rate));
          } else {
            assistIndex = this.getUnitIndex(1, item.Units);
            assistData = this.getUnitValue(item.Units, assistIndex);
            item.Rate = parseFloat(this.getIinvexchrate(data.Rate));
          }
          item.UnitId2 = assistData.UnitId;
          item.Unit2Name = assistData.UnitName;
          this.changeQuantity(item.PurchaseQuantity, item, i);
          // row.ChangeType2 = assistData.ChangeType;
        }
        // item.Units.forEach(v=>{
        //   if(v.ChangeType==1)item.ChangeType=v.ChangeType
        // })
        // if (item.Units.length > 0 && item.PuUnitId) {
        //   const findIndex = item.Units.findIndex(el => el.UnitId == item.PuUnitId)
        //   // let  data=this.getUnitValue(item.Units,findIndex)
        //   // item.IsMain =data.IsMain
        //   const IsMainIndex = item.Units.findIndex(el=>el.IsMain==true) //主单位的索引
        //   const UnitId2Index = item.Units.findIndex(el=>el.UnitId==item.UnitId2) //不是主单位的索引
        //   const noMainIndex = item.Units.findIndex(el=>el.IsMain==false)
        //   if(findIndex==IsMainIndex){ //判断当前销售单位是否为主单位
        //     item.Rate=item.Units[UnitId2Index != -1?UnitId2Index:noMainIndex].Rate || 0
        //     item.ChangeType=item.Units[UnitId2Index != -1?UnitId2Index:noMainIndex].ChangeType || 0
        //     item.IsMain = true;
        //   }else{
        //     //如果当前是赋单位
        //     item.Rate=item.Units[findIndex].Rate
        //     item.ChangeType=item.Units[findIndex].ChangeType
        //     item.IsMain = false;
        //   }
        // } else {
        //   item.Units.forEach(v=>{
        //     if(v.ChangeType==1)item.ChangeType=v.ChangeType
        //   })
        // }
      });
      console.log(addList, "addList");
      this.tableList.unshift(...addList);
      if (this.data.TradeUnitId) {
        this.isSelect = true;
      }
    },

    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    currentPage({ val, text1 }, row) {
      this.pageParams.pageIndex = val;
      this.pdApi
        .list({
          Property: "采购",
          pageIndex: val,
          pageSize: 7,
          Status: 1,
          ProductName: text1,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    inputText(text, row) {
      row.ProductName = text;

      this.pdApi
        .list({
          Property: "采购",
          pageIndex: 1,
          pageSize: 7,
          Status: 1,
          ProductName: text,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    setProduct(row, index) {
      let data = this.productList.filter(
        (item) => item.ProductId === row.ProductId
      );
      this.tableList[index].ProductName = data[0].ProductName;
      this.tableList[index].ProductNo = data[0].ProductNo;
      this.tableList[index].ProductSpec = data[0].ProductSpec;
      this.tableList[index].PuUnitId = data[0].PuUnitId;
      this.tableList[index].UnitName = data[0].UnitName;
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    // 选择存货名称
    onSelect(e, row, index) {
      console.log("e", e);
      row.UseProcess = e.UseProcess;
      if (row.SourceDocNo && row.ProductId != e.ProductId) {
        // this.data.TradeUnitId = '';
        // this.$nextTick(() => {
        //   this.$refs.ruleForm.clearValidate();
        // })
        row.SourceType = 0;
        // SourceDtsId:item.
        row.SourceDocId = 0;
        row.SourceDtsId = 0;
        row.SourceDocNo = "";
      }
      if (row.T === 3 && row.ProductId !== e.ProductId) row.T = 1;
      row.ProductNo = e.ProductNo;
      row.BatchNumber = null
      row.IsBatchNumber = e.BatchNumber ?? false
      row.BatchStartDate = row.IsBatchNumber ? row.BatchStartDate : null
      row.HasGrammage = e.HasGrammage ?? false
      row.Grammage = e.Grammage ?? 0
      row.ProductName = e.ProductName;
      row.ProductId = e.ProductId;
      row.ProductSpec = e.ProductSpec;
      row.PuUnitId = e.PuUnitId;
      row.UnitName = e.PuUnitName;
      row.UnitId2 = e.UnitId2;
      row.ColorId = null;
      row.UseColor = e.UseColor;
      row.UnitType = 0;
      row.Colors = e.Colors;
      row.Units = e.Units;
      // row.Units = e.Units;
      row.UnitId = e.PdUnitId;
      row.ChangeType = 0;
      //  row.SaUnitId=e.PdUnitId;
      row.SaUnitName = e.PdUnitName;
      //ExecutionQuantity累计数量
      row.ExistQuantity = e.ExistQuantity;
      row.StockQuantity = e.StockQuantity;
      // this.colorList = e.Colors;
      // this.optionList = e.Units;
      console.log("PurchaseQuantity", Number(row.PurchaseQuantity));
      if (!Number(row.PurchaseQuantity)) row.PurchaseQuantity = null;
      // if (e.UnitType === 0) {
      //   row.UnitId2 = e.SaUnitId;
      //   row.UnitName2 = e.UnitName;
      // }

      //
      if (e.Units.length === 0) {
        row.UnitName = e.PuUnitName;
        row.UnitId2 = 0;
        row.SaUnitName = e.SaUnitName;
        row.Unit2Name = "";
        row.Rate = 0;
        row.Quantity2 = 0;
      } else {
        e.Units.forEach((item) => {
          if (item.ChangeType == 1) row.ChangeType = item.ChangeType;
        });
        row.UnitType = 1;
        if (row.PuUnitId) {
          let index = this.getUnitIndex(3, e.Units, row.PuUnitId);
          let data = this.getUnitValue(e.Units, index);
          let assistIndex = 0;
          let assistData = {};
          row.IsMain = data.IsMain;
          row.UnitName=data.UnitName;
          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, e.Units);
            assistData = this.getUnitValue(e.Units, assistIndex);
            row.Rate = parseFloat(this.getIinvexchrate(assistData.Rate));
          } else {
            assistIndex = this.getUnitIndex(1, e.Units);
            assistData = this.getUnitValue(e.Units, assistIndex);
            row.Rate = parseFloat(this.getIinvexchrate(data.Rate));
          }
          row.UnitId2 = assistData.UnitId;
          row.Unit2Name = assistData.UnitName;
        } else {
          let untiLength = e.Units.length;
          let mainData = [];
          let noMainData = [];
          for (let i = 0; i < untiLength; ++i) {
            if (e.Units[i].IsMain) {
              mainData.push(e.Units[i]);
            } else {
              noMainData.push(e.Units[i]);
            }
          }
          row.PuUnitId = mainData[0].UnitId;
          row.UnitName = mainData[0].UnitName;
          row.UnitId2 = noMainData[0].UnitId;
          row.Unit2Name = noMainData[0].UnitName;
          row.Rate = parseFloat(this.getIinvexchrate(noMainData[0].Rate));;
          row.IsMain = true;
        }
        if (row.IsMain) {
          if (row.HasGrammage == true) {
            row.Quantity2 = this.getQuantity(row.PurchaseQuantity * row.Rate)
          } else {
            row.Quantity2 = this.getQuantity(row.PurchaseQuantity / row.Rate)
          }
          //row.Quantity2 = this.getQuantity(row.PurchaseQuantity / Number(row.Rate));
        } else {
          if (row.HasGrammage == true) {
            row.Quantity2 = this.getQuantity(row.PurchaseQuantity / row.Rate)
          } else {
            row.Quantity2 = this.getQuantity(row.PurchaseQuantity * row.Rate)
          }
          //row.Quantity2 = this.getQuantity(row.PurchaseQuantity * Number(row.Rate));
        }
        row.Amount = Number(row.Price ?? 0) * Number(row.PurchaseQuantity ?? 0);
        row.TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0);
      }
      // if (e.Units.length > 0) {
      //   const UnitIds = e.Units.map((i) => i.UnitId);
      //   const index =
      //     UnitIds.indexOf(e.SaUnitId) === e.Units.length
      //       ? 0
      //       : UnitIds.indexOf(e.SaUnitId) + 1;
      //   // row.UnitId2 = UnitIds[index];
      //   const saleData = e.Units.filter((i) => i.UnitId === e.SaUnitId)[0];
      //   const unitData = e.Units.filter((i) => i.UnitId === UnitIds[index])[0];
      //   // row.Rate = unitData.Rate / saleData.Rate;
      //   // row.Quantity2 = (row.PurchaseQuantity * row.Rate).toFixed(2);
      //   // row.UnitChangeType = unitData.ChangeType;
      // }
      //   let _colorShow=this.tableList.find(item=>item.UseColor==true)
      //  if(_colorShow){
      //   this.tableColorShow=true
      //  }else{
      //   this.tableColorShow=false
      //  }
      this.api
        .productPrice({
          TradeUnitId: this.data.TradeUnitId ?? 0,
          ProductId: e.ProductId,
        })
        .then((res) => {
          if (res.Data) {
            row.SalePrice = res.Data.SalePrice;
            row.RetailPrice = res.Data.RetailPrice;
            row.PurchasePrice = res.Data.PurchasePrice;
            row.SaCostPrice = res.Data.SaCostPrice;
            row.Offer = res.Data.RetailPrice;
            row.Price = res.Data.RetailPrice;
            row.TaxPrice = res.Data.RetailPrice;
            this.changeOffer(row, index);
          }
        });
    },
    RateChange(data, row, index) {
      if (data < 0 || data == "") return;
      if (row.T === 3) row.T = 1;
      this.changeQuantity(this.tableList[index].PurchaseQuantity, row, index);
    },
    compareSaUnit(data, row, index) {
      if (row.T === 3) row.T = 1;
      this.tableList[index].IsMain = data.IsMain;
      let findIndex = 0;
      if (row.PuUnitId == row.UnitId2) {
        let num = 0;
        num = row.PurchaseQuantity;
        row.PurchaseQuantity = row.Quantity2;
        row.Quantity2 = num;
        if (data.IsMain) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableList[index].Units);
          this.changeRightUnitId(index, findIndex);
        } else {
          findIndex = this.getUnitIndex(1, this.tableList[index].Units);
          this.changeRightUnitId(index, findIndex);
        }
      } else {
        if (data.IsMain) {
          findIndex = this.getUnitIndex(2, this.tableList[index].Units);
          this.changeRightUnitId(index, findIndex);
        } else {
          findIndex = this.getUnitIndex(1, this.tableList[index].Units);
          this.changeRightUnitId(index, findIndex, data.Rate);
        }
      }
      this.changeQuantity(this.tableList[index].PurchaseQuantity, row, index);
    },
    //传入数组 索引 返回对应的 id 和name index是table索引  findIndex 是当前主辅单位索引
    changeRightUnitId(index, findIndex, Rate = 0) {
      this.tableList[index].UnitId2 =
        this.tableList[index].Units[findIndex].UnitId;
      this.tableList[index].UnitName2 =
        this.tableList[index].Units[findIndex].UnitName;
      if (Rate > 0) {
        this.tableList[index].Rate = parseFloat(this.getIinvexchrate(Rate));;
      }
    },
    changeQuantity2(data, row, index) {
      if (data < 0 || data == "") return;

      data = this.getQuantity(data)
      row.Quantity2 = data;
      if (row.T === 3) row.T = 1;
      if (row.IsMain == false) {
        if (row.ChangeType == 1) {
          if (row.PurchaseQuantity === "" || row.PurchaseQuantity === 0) return;
          //row.Rate = parseFloat(this.getIinvexchrate(data / row.PurchaseQuantity));
          if (row.HasGrammage == true) {
            row.PurchaseQuantity =parseInt(this.getQuantity(data * row.Rate))
          } else {
            row.Rate = this.getIinvexchrate(data / row.PurchaseQuantity)
          }
        } else {
          console.log("数量1=数量2/换算率");
          row.PurchaseQuantity = this.getQuantity(data / row.Rate);
        }
      } else {
        if (row.ChangeType == 1) {
          if (row.PurchaseQuantity === "" || row.PurchaseQuantity === 0) return;
          ///row.Rate = parseFloat(this.getIinvexchrate(row.PurchaseQuantity / data));
           if (row.HasGrammage == true) {
              row.PurchaseQuantity =parseInt(this.getQuantity(data / row.Rate)) 
            } else {
              row.Rate = this.getIinvexchrate(row.PurchaseQuantity / data)
            }
        } else {
          console.log("数量1=数量2*换算率");
          row.PurchaseQuantity = this.getQuantity(data * row.Rate);
        }
      }
      row.Amount = row.PurchaseQuantity *  row.Offer
    },
    getChangeQuantity(data, row, index) {
      if (row.PurchaseQuantity === "" || row.PurchaseQuantity === 0) {
        if (row.Quantity2 && row.Rate) {
          if (row.IsMain) {
            row.PurchaseQuantity = this.getQuantity(row.Quantity2 * Number(row.Rate));
          } else {
            row.PurchaseQuantity = this.getQuantity(row.Quantity2 / Number(row.Rate));
          }
        }
      }
    },
    getUnitValue(arr, findIndex) {
      let data = {};
      data.UnitId = arr[findIndex].UnitId;
      data.UnitName = arr[findIndex].UnitName;
      data.IsMain = arr[findIndex].IsMain;
      data.ChangeType = arr[findIndex].ChangeType;
      data.Rate = arr[findIndex].Rate;
      return data;
    },
    //获取计量单位主辅单位的索引
    getUnitIndex(type, arr, id = "") {
      let index = 0;
      if (type == 1) {
        //获取主单位索引
        index = arr.findIndex((el) => el.IsMain == true);
      } else if (type == 2) {
        //获取数组第一个不是主单位的索引
        index = arr.findIndex((el) => el.IsMain == false);
      } else {
        //获取当前传入id的索引
        index = arr.findIndex((el) => id == el.UnitId);
      }
      return index;
    },
    changeLeftUnitId(index, findIndex, Rate = 0) {
      this.tableList[index].PuUnitId =
        this.tableList[index].Units[findIndex].UnitId;
      this.tableList[index].SaUnitName =
        this.tableList[index].Units[findIndex].UnitName;
      if (Rate > 0) {
        this.tableList[index].Rate = parseFloat(this.getIinvexchrate(Rate));
      }
    },
    compareUnitId(data, row, index) {
      if (row.T === 3) row.T = 1;
      if (data.IsMain) {
        this.tableList[index].IsMain = false;
      } else {
        this.tableList[index].IsMain = true;
      }
      let findIndex = 0;
      if (row.PuUnitId == row.UnitId2) {
        let num = 0;
        num = row.PurchaseQuantity;
        row.PurchaseQuantity = row.Quantity2;
        row.Quantity2 = num;
        if (this.tableList[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableList[index].Units);
          this.changeLeftUnitId(index, findIndex);
        } else {
          findIndex = this.getUnitIndex(1, this.tableList[index].Units);
          this.changeLeftUnitId(index, findIndex);
        }
      } else {
        if (this.tableList[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableList[index].Units);
          this.changeLeftUnitId(index, findIndex);
        } else {
          findIndex = this.getUnitIndex(1, this.tableList[index].Units);
          this.changeLeftUnitId(index, findIndex, data.Rate);
        }
      }
      this.changeQuantity2(this.tableList[index].Quantity2, row, index);
      row.Amount = row.PurchaseQuantity *  row.Offer
    },
    addColumn(row, column) {
      if (row.index === this.tableList.length - 1 && !this.ReviewStatus) {
        this.addList();
      }
    },
    // compareUnitId(data, row, index) {
    //   console.log("data", data);

    //   this.isMainUnitId2 = true;
    //   this.tableList[index].Rate = data.UnitId === row.SaUnitId ? 1 : data.Rate;
    //   row.UnitChangeType = data.ChangeType;
    //   if (data.ChangeType === 0)
    //     row.Quantity2 = row.PurchaseQuantity * row.Rate;
    //   if (data.ChangeType === 1 && Number(row.Quantity2) != 0)
    //     row.Rate = row.Quantity2 / row.PurchaseQuantity;
    // },
    changeDeliveryDate(row) {
      if (row.T === 3) row.T = 1;
    },
    changeIsGift(data, row) {
      if (row.T === 3) row.T = 1;
      if (data) {
        row.Offer = 0;
        row.Discount = 0;
        row.TaxRate = 0;
        row.Price = 0;
        row.TaxPrice = 0;
        row.Amount = 0;
        row.TaxLimit = 0;
        row.TaxAmount = 0;
        row.DiscountAmount = 0;
      }
    },
    RestartOrder() {
      this.$message.success("新增");
      Object.assign(this.$data, this.$options.data.call(this));
      this.init();
      this.createOrder();
      this.addList();

      setTimeout(() => {
        this.$refs.ruleForm.clearValidate();
      }, 30);
    },

    orderUpdate() {
      this.$message.success("变更");
      this.is_orderUpdateStatus = true;
    },
    Review() {
      this.api.review(this.data.OrderId).then((res) => {
        this.data.Status = 2;
        res.Code === 0
          ? this.$message.success(res.Msg)
          : this.$message.warning(res.Msg);

        if (res.Code === 0) {
          this.editOrder(this.data.OrderId);
          // this.api.info(this.data.OrderId).then((res) => {
          //   this.data = res.Data;
          // });
        }
      });
    },
    orderReview() {
      if (this.data.OrderId == 0) {
        this.$message.warning("订单未保存");
        return;
      }
      const message =
        this.data.Status == 2 ? "确认要弃审吗？ " : "确认提交审核吗？";
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const data = this.data.Status == 2 ? "back" : "review";
          if (data === "review") {
            this.save(1);
          } else if (data === "back") {
            this.api[data](this.data.OrderId).then((res) => {
              if (res.Code === 0 && data == "review") {
                this.data.Status = 2;
              }
              if (res.Code === 0 && data == "back") this.data.Status = 0;
              res.Code === 0
                ? this.$message.success(res.Msg)
                : this.$message.warning(res.Msg);

              if (res.Code === 0) {
                this.editOrder(this.data.OrderId);
                // this.api.info(this.data.OrderId).then((res) => {
                //   this.data = res.Data;
                // });
              }
            });
          }

          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => { });
    },
    orderDel() {
      // let rows = this.$refs.list.getCheckedRows();
      if (this.data.OrderId == 0) {
        this.$message.warning("订单未保存");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.delete({ Id: this.data.OrderId }).then((res) => {
            if (res.Code === 0) this.RestartOrder();
            res.Code === 0
              ? this.$message.success(res.Msg)
              : this.$message.warning(res.Msg);
          });
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => { });
    },
    delTableList(data, index) {
      // if (data.OrderNo) {
      //   this.data.TradeUnitId = '';
      //   this.$nextTick(() => {
      //     this.$refs.ruleForm.clearValidate();
      //   })
      // }
      // this.$message.success("删除");
      this.tableList.splice(index, 1);

      console.log(this.tableList, "第index个被删除", data);
      if (this.tableList.length === 0) {
        this.addList();
      }

      let pds = this.tableList.filter((item) => {
        return item.ProductId !== 0;
      });
      if (pds.length === 0) {
        this.isSelect = false;
      }
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    setEmp(data) {
      console.log(data);
      this.data.ClerkId = data.EmpId;
      this.data.ClerkName = data.EmpName;
      this.data.DpId = data.DpId;
      this.data.DpName = data.DpName;
      this.data.DpNo = data.DpNo;
    },

    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.PropertyId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => { });
    },
    openSales(row, index) {
      this.currentRow = row;
      this.currentIndex = index;
      let ProductName = row.ProductName;
      let TradeUnitName = this.data.TradeUnitName;

      this.$refs.orderDialog.open().then((that) => {
        that.setData(ProductName, TradeUnitName);
      });
    },

    setTradeunit(data) {
      this.data.TradeUnitId = data.TradeUnitId;
      this.data.TradeUnitName = data.FullName;
      this.data.TradeUnitType = data.TradeUnitType;
      console.log("data", data);
      if (data.TradeUnitId) {
        this.tradeUnitApi.info(data.TradeUnitId).then((res) => {
          if (res.Code == 0) {
            if (res.Data.PaymentSet) {
              if (res.Data.PaymentSet.PaymentType > 0) {
                this.data.PayId = Number(res.Data.PaymentSet.PaymentType);
              } else {
                this.data.PayId = null;
              }
            }
          }
        });
      }
    },
    // 貌似需要审核后才可以进行 修改 行中止
    changeLineAbort(data, row) {
      if (this.data.OrderId == 0 || row.OrderProductId == 0)
        return (row.LineAbort = false);
      this.api
        .lineAbort({
          Id: row.OrderProductId,
          IsLineAbort: Number(data) ? true : false,
        })
        .then((res) => {
          if (res.Code === 1) {
            row.LineAbort = !data;
            return this.$message.error(res.Msg);
          }
        });
    },

    changeColor(row, index) {
      if (row.T === 3) this.tableList[index].T = 1;
      var pm = { ProductId: row.ProductId, ColorId: row.ColorId };
      if (row.PropertyId) {
        pm.PropertyId = row.PropertyId;
      }
      this.pdApi.stockInfo(pm).then((res) => {
        if (res.Code == 0) {
          row.ExistQuantity = res.Data.AvailableQuantity;
          row.StockQuantity = res.Data.StockQuantity;
        }
      });
    },
    validInput(row, index, type) {
      if (row.T === 3) this.tableList[index].T = 1;
      if (!Number(row.PurchaseQuantity)) {
        this.$message.warning("请先填写数量");
        return true;
      }
      return false;
    },

    changeQuantity(data, row, index) {
      if (data == "-" || data == "." || data == "") {
        return;
      }

      data = Number(this.getQuantity(data));
      row.PurchaseQuantity = data;


      if (this.data.MinusEntry) {
        row.PurchaseQuantity > 0
          ? (row.PurchaseQuantity = 0 - row.PurchaseQuantity)
          : row.PurchaseQuantity;
        row.Quantity2 > 0 ? (row.Quantity2 = 0 - row.Quantity2) : row.Quantity2;
        data = data > 0 ? 0 - data : data;
      } else {
        row.PurchaseQuantity = Math.abs(row.PurchaseQuantity);
        row.Quantity2 = Math.abs(row.Quantity2);
        data = Math.abs(data);
      }
      if (row.T == 3) this.tableList[index].T = 1;
      if (row.UnitType === 1) {
        if (row.IsMain) {
          if (row.HasGrammage == true) {
            row.Quantity2 = this.getQuantity(row.PurchaseQuantity * row.Rate)
          } else {
            row.Quantity2 = this.getQuantity(row.PurchaseQuantity / row.Rate)
          }
          // row.Quantity2 = (row.PurchaseQuantity / Number(row.Rate))
          // row.Quantity2 = this.getQuantity(row.Quantity2)
        } else {
           if (row.HasGrammage == true) {
          row.Quantity2 = this.getQuantity(row.PurchaseQuantity / row.Rate)
        } else {
          row.Quantity2 = this.getQuantity(row.PurchaseQuantity * row.Rate)
        }
          // row.Quantity2 = (row.PurchaseQuantity * Number(row.Rate))
          // row.Quantity2 = this.getQuantity(row.Quantity2)
        }
      } else {
        row.Quantity2 = row.PurchaseQuantity;
        row.Quantity2 = this.getQuantity(row.Quantity2)
      }
      //if (this.optionList.length === 0)
      // row.Quantity2 = Number(row.PurchaseQuantity);
      // if (this.optionList.length > 0 && row.UnitId2 != 0) {
      //   const mainList = this.optionList
      //     .filter((i) => i.IsMain)
      //     .map((sub) => sub.UnitId);
      //   if (mainList.includes(row.SaUnitId) && this.isMainUnitId2 == false)
      //     row.Quantity2 = row.PurchaseQuantity / row.Rate;
      //   else if (!mainList.includes(row.SaUnitId) && this.isMainUnitId2 == true)
      //     row.Quantity2 = row.PurchaseQuantity * row.Rate;
      //   else row.Quantity2 = Number(row.PurchaseQuantity);
      // } else row.Quantity2 = Number(row.PurchaseQuantity);
      // 金额
      if (Number(row.Price)) {
        let Amount =
          Number(row.Price) * data * (Number(row.Discount ?? 0) / 100);
        this.tableList[index].Amount = Number(Amount.toFixed(2));
      }

      // 税额
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxLimit = Number(row.Price) * data * (Number(row.TaxRate) / 100);
        this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2));
      }

      // 含税单价
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate))) / 100;
        this.tableList[index].TaxPrice = this.getPrice(TaxPrice);
      }

      // 含税金额
      if (Number(row.Amount) || Number(row.TaxLimit)) {
        let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }

      // 折扣金额
      if (Number(row.Offer) && Number(row.Price)) {
        let DiscountAmount =
          (Number(row.Offer) - Number(row.Price)) * Number(data);
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));
      }
    },
    // // 数量2
    // changeQuantity2(row, index) {
    //   console.log("输出", row.UnitChangeType);
    //   if (this.optionList.length === 0)
    //     return (row.PurchaseQuantity = row.Quantity2);
    //   if (this.optionList.length > 0) {
    //     if (row.UnitChangeType == 0) {
    //       console.log("执行");
    //       row.PurchaseQuantity = row.Quantity2 / row.Rate;
    //       return this.changeQuantity(row.PurchaseQuantity, row, index);
    //     }
    //     if (row.UnitChangeType == 1) {
    //       return (row.Rate = row.Quantity2 / row.PurchaseQuantity);
    //     }
    //   }
    // },
    // 报价
    changeOffer(row, index) {
      if (row.T === 3) this.tableList[index].T = 1;
      // 修改单价
      let Price = (row.Discount / 100) * row.Offer;
      this.tableList[index].Price = Price < 0 ? 0 : this.getPrice(Price);

      //修改金额
      let Amount = Number(row.Price ?? 0) * Number(row.PurchaseQuantity ?? 0);
      this.tableList[index].Amount = Number(Amount.toFixed(2));

      //修改含税单价
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate))) / 100;
        this.tableList[index].TaxPrice = this.getPrice(TaxPrice)
      }

      // 折扣金额
      if (Number(row.Offer) && Number(row.Price)) {
        let DiscountAmount =
          (Number(row.Offer) - Number(row.Price)) *
          Number(row.PurchaseQuantity);
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));
      }

      // 税额
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxLimit =
          Number(row.Price) *
          Number(row.PurchaseQuantity) *
          (Number(row.TaxRate) / 100);
        this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2));
      }

      // 含税金额
      if (Number(row.Amount) || Number(row.TaxLimit)) {
        let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 折扣
    changeDiscount(row, index) {
      if (this.validInput(row, index, "Discount")) return;
      if (row.T == 3) this.tableList[index].T = 1;
      // 修改单价
      let Price = (row.Discount / 100) * row.Offer;
      this.tableList[index].Price = Price < 0 ? 0 : this.getPrice(Price)

      //修改金额
      let Amount = Number(row.Price ?? 0) * Number(row.PurchaseQuantity ?? 0);
      this.tableList[index].Amount = Number(Amount.toFixed(2));

      //修改含税单价
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate))) / 100;
        this.tableList[index].TaxPrice = this.getPrice(TaxPrice);
      }

      // 折扣金额
      if (Number(row.Offer) && Number(row.Price)) {
        let DiscountAmount =
          (Number(row.Offer) - Number(row.Price)) *
          Number(row.PurchaseQuantity);
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));
      }

      // 税额
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxLimit =
          Number(row.Price) *
          Number(row.PurchaseQuantity) *
          (Number(row.TaxRate) / 100);
        this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2));
      }

      // 含税金额
      if (Number(row.Amount) || Number(row.TaxLimit)) {
        let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 单价
    changePrice(row, index) {
      if (this.validInput(row, index, "Price")) return;


      if (row.T == 3) this.tableList[index].T = 1;

      row.Price = this.getPrice(row.Price);

      let quantityNum = 0;
      if (row.Units.length === 0) {
        quantityNum = row.PurchaseQuantity;
      } else {
        if (row.IsMain) {
          quantityNum = row.PurchaseQuantity;
        } else {
          quantityNum = row.Quantity2;
        }
      }
      row.quantityNum = quantityNum;

      let rate = null;

      if (
        row.Offer == 0 ||
        row.Offer == null ||
        row.Offer == ""
      ) {
        rate = this.tableList[index].Discount / 100;
        if (rate === 1) {
          row.Offer = row.Price;
        } else {
          row.Offer = Number((row.Price * row.Discount).toFixed(2));
        }
      } else {
        rate = (Number(row.Price) / Number(row.Offer)) * 100;
        this.tableList[index].Discount = Number(rate.toFixed(5));
      }

      row.changeMode = 1;

      // 修改单价
      let equation = null;
      if (row.Discount == 100) {
        equation = Number(row.Offer);
      } else {
        equation = row.Price;
      }

      // 金额
      if (Number(row.quantityNum)) {
        console.log("row.quantityNum", row.quantityNum);
        let Amount = equation * Number(row.quantityNum);
        console.log("equation", equation);
        this.tableList[index].Amount = Number(Amount.toFixed(2));
      }

      // 修改含税单价
      let TaxPrice = (equation * (100 + Number(row.TaxRate))) / 100;
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : this.getPrice(TaxPrice);

      // this.changeDiscount(row, index);

      if (Number(row.Offer)) {
        // this.tableList[index].TaxPrice = Number(equation) < 0 ? 0 :  parseFloat(Number(equation).toFixed(2));
        // this.tableList[index].Price = equation < 0 ? 0 : equation.toFixed(2);

        // 折扣金额
        let DiscountAmount = 0;
        DiscountAmount = (row.Offer - equation) * row.quantityNum;

        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));
      }
      if (Number(row.TaxRate)) {
        let TaxLimit = equation * row.quantityNum * (row.TaxRate / 100);
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2));
        // this.changeTaxRate(row, index);
      }

      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit ?? 0);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 税率
    changeTaxRate(row, index) {
      if (this.validInput(row, index, "TaxRate")) return;
      if (row.T == 3) this.tableList[index].T = 1;

      row.TaxRate = parseFloat(this.getIinvexchrate(TaxRate))
      // 修改税额
      let TaxLimit =
        Number(row.Price ?? 0) *
        Number(row.PurchaseQuantity) *
        ((row.TaxRate ?? 0) / 100);
      this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2));

      // 修改含税单价
      let TaxPrice = (row.Price * (100 + Number(row.TaxRate))) / 100;
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : this.getPrice(TaxPrice);

      // 含税金额
      let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0);
      this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
    },
    // 含税单价
    changeTaxPrice(row, index) {
      if (this.validInput(row, index, "TaxPrice")) return;
      if (row.T == 3) this.tableList[index].T = 1;
      // 修改单价
      let Price = row.TaxPrice / (1 + row.TaxRate / 100);
      this.tableList[index].Price = this.getPrice(Price);

      // 修改折扣率
      let rate = (Number(row.Price) / Number(row.Offer)) * 100;
      this.tableList[index].Discount = Number(rate.toFixed(5));

      // 修改金额
      let Amount =
        Number(row.Price) * Number(row.PurchaseQuantity) * (row.Discount / 100);
      this.tableList[index].Amount = Number(Amount.toFixed(2));

      // 折扣金额
      let DiscountAmount = 0;
      DiscountAmount = (row.Offer - Number(row.Price)) * row.PurchaseQuantity;
      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));

      if (Number(row.TaxRate)) {
        let TaxLimit =
          Number(row.Price) *
          Number(row.PurchaseQuantity) *
          (Number(row.TaxRate) / 100);
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2));
        // this.changeTaxRate(row, index);
      }

      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 税额
    changeTaxLimit(row, index) {
      if (this.validInput(row, index, "TaxLimit")) return;
      if (row.T == 3) this.tableList[index].T = 1;

      if (row.changeMode === 0 || row.changeMode == null) {
        // 修改金额
        let Amount = Number(row.TaxAmount) - Number(row.TaxLimit);
        this.tableList[index].Amount = Number(Amount.toFixed(2));

        // 修改单价
        let Price = Number(row.Amount) / Number(row.PurchaseQuantity);
        this.tableList[index].Price = this.getPrice(Price);


        // 修改折扣率
        let rate = (Number(row.Price) / Number(row.Offer)) * 100;
        this.tableList[index].Discount = Number(rate.toFixed(5));

        // 修改含税单价
        let TaxPrice =
          (Number(row.Price) * (100 + Number(row.TaxRate ?? 0))) / 100;
        this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : this.getPrice(TaxPrice);

        // 折扣金额
        let DiscountAmount = 0;
        DiscountAmount = (row.Offer - Number(row.Price)) * row.PurchaseQuantity;
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));

        // 修改含税金额
        if (Number(row.TaxLimit) || Number(row.Amount)) {
          let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
          this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
        }
      } else {
        // 修改含税金额
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));

        // 修改含税单价
        let TaxPrice = Number(row.TaxAmount) / Number(row.PurchaseQuantity);
        this.tableList[index].TaxPrice = this.getPrice(TaxPrice);
      }
    },
    // 金额
    changeAmount(row, index) {
      if (this.validInput(row, index, "Amount")) return;
      if (row.T == 3) this.tableList[index].T = 1;

      // 修改单价
      let Price = Number(row.Amount) / Number(row.PurchaseQuantity);
      this.tableList[index].Price = this.getPrice(Price);

      // 修改报价
      if (Number(this.tableList[index].Discount) === 100) {
        row.Offer = this.tableList[index].Price;
      }

      // 修改折扣率
      let rate = (Number(row.Price) / Number(row.Offer)) * 100;
      this.tableList[index].Discount = Number(rate.toFixed(5));

      // 折扣金额
      let DiscountAmount = 0;
      DiscountAmount = (row.Offer - Number(row.Price)) * row.PurchaseQuantity;
      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));

      // this.changePrice(row, index)
      // 修改含税单价
      if (Number(row.TaxRate)) {
        let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate))) / 100;
        this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : this.getPrice(TaxPrice);
      }

      // 修改税额
      if (Number(row.TaxRate)) {
        let TaxLimit =
          Number(row.Price) * Number(row.PurchaseQuantity) * (row.TaxRate / 100);
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2));
        // this.changeTaxRate(row, index);
      }

      // 修改含税金额
      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 含税金额
    changeTaxAmount(row, index) {
      if (this.validInput(row, index, "TaxAmount")) return;

      if (row.T == 3) this.tableList[index].T = 1;

      row.changeMode = 0;

      // 修改金额
      let Amount = Number(row.TaxAmount) - Number(row.TaxLimit);
      this.tableList[index].Amount = Number(Amount.toFixed(2));

      // 修改单价
      let Price = Number(row.Amount) / Number(row.PurchaseQuantity);
      this.tableList[index].Price = this.getPrice(Price);

      // 修改折扣率
      let rate = (Number(row.Price) / Number(row.Offer)) * 100;
      this.tableList[index].Discount = Number(rate.toFixed(5));

      // 修改含税单价
      let TaxPrice = Number(row.TaxAmount) / Number(row.PurchaseQuantity);
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : this.getPrice(TaxPrice);

      // 折扣金额
      let DiscountAmount = 0;
      DiscountAmount = (row.Offer - Number(row.Price)) * row.PurchaseQuantity;
      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));
    },
    // 折扣金额
    changeDiscountAmount(row, index) {
      if (this.validInput(row, index, "DiscountAmount")) return;
      if (row.T == 3) this.tableList[index].T = 1;

      // 修改单价
      let Price = row.Offer - row.DiscountAmount / row.PurchaseQuantity;
      this.tableList[index].Price = this.getPrice(Price);

      // 修改折扣率

      let rate = (Number(row.Price) / Number(row.Offer)) * 100;
      this.tableList[index].Discount = Number(rate.toFixed(5));

      // 金额
      let Amount =
        Number(row.Price) *
        Number(row.PurchaseQuantity) *
        (Number(row.Discount) / 100);
      this.tableList[index].Amount = Number(Amount.toFixed(2));

      // 修改含税单价
      if (Number(row.TaxRate)) {
        let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate))) / 100;
        this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : this.getPrice(TaxPrice);
      }

      // 修改税额
      if (Number(row.TaxRate)) {
        let TaxLimit =
          Number(row.Price) * Number(row.PurchaseQuantity) * (row.TaxRate / 100);
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2));
        // this.changeTaxRate(row, index);
      }

      // 修改含税金额
      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 单价弹窗
    renderHeader(h, { column }) {
      return h("div", [
        h("span", column.label),
        h("i", {
          class: "el-icon-s-order",
          style: "font-size:14px;cursor: pointer;",
          on: {
            click: this.openSales,
          },
        }),
      ]);
    },
    openPrint() {
      this.columnkey = saleList.Data.map((i) => i.tableName);
      this.columns = saleList.Data.reduce((acc, item) => {
        let print = { ...item.print, key: item.tableName, label: item.label };
        acc.push({ label: item.label, data: print });
        return acc;
      }, []);
      this.formData = saleList.Data.reduce((acc, item) => {
        return acc.concat({
          key: item.tableName,
          label: item.label,
          value: this.data[item.tableName],
        });
      }, []);
      this.$refs.printDialog.open();
      s;
    },
    onPrint2(row) {
      var url = location.origin + "/#/customprintview/采购订单/" + row.OrderId;
      window.open(url, "_blank");
    },


    onPrint(row) {
      let newpage = this.$router.resolve({
        path: "/emptorPrint?id=" + row.OrderId,
      });
      window.open(newpage.href, "_blank");
    },
    save(type = 0) {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return false;
        const Product = JSON.parse(JSON.stringify(this.data.Products));
        const TableList = JSON.parse(JSON.stringify(this.tableList));
        if (this.deleteDateList.length > 0)
          this.data.Pays = this.data.Pays.concat(this.deleteDateList);

        // 清除没有产品的数据
        this.tableList = this.tableList.filter((i) => i.ProductId != 0);
        for (let i = 0; i <= this.tableList.length - 1; i++) {
          if (this.tableList[i].Amount < 0) return this.$message.warning("金额不能小于0");
          if (
            this.tableList[i].PurchaseQuantity == null ||
            this.tableList[i].PurchaseQuantity == 0
          )
            return this.$message.warning("数量不能为空并且不为0");
          if (
            this.tableList[i].UnitId2 == null &&
            this.tableList[i].UnitType == 1
          )
            return this.$message.warning("计量单位2不能为空");
          if (
            this.tableList[i].UseColor &&
            (this.tableList[i].ColorId === 0 ||
              this.tableList[i].ColorId == null)
          ) {
            this.$message.error(
              `存货${this.tableList[i].ProductName}未填写颜色`
            );
            return;
          }
          // if (
          //   this.tableList[i].UseProcess &&
          //   (this.tableList[i].PropertyId === 0 ||
          //     this.tableList[i].PropertyId == null)
          // ) {
          //   this.$message.error(
          //     `存货${this.tableList[i].ProductName}未填写属性`
          //   );
          //   return;
          // }
        }
        // if (this.tableList.filter((i) => i.UnitId2 === null).length > 0)
        //   return this.$message.warning("计量单位2不能为空");
        // if (
        //   this.tableList.filter((i) => i.PurchaseQuantity === null).length > 0
        // )
        //   return this.$message.warning("数量不能为空");
        // if (this.tableList.filter((i) => i.DeliveryDate == "").length !== 0)
        //   return this.$message.warning("交货日期不能为空");
        // //

        if (this.data.Products.length > 0) {
          // let delIds = this.tableList.map((item) => item.ProductId);
          // let delList = this.data.Products.reduce((arr, item) => {
          //   if (!delIds.includes(item.ProductId)) arr.push({ ...item, T: 2 });
          //   return arr;
          // }, []);
          let delList = [];
          var delIds = this.tableList.map(x => { return x.OrderProductId });
          this.data.Products.forEach(e => {
            let p = delIds.indexOf(e.OrderProductId);
            if(p == -1) {
              delList.push({ ...e, T: 2 });
            }
          })
          //----------
          
          let addIds = this.data.Products.map((item) => item.OrderProductId);
          let addList = [];
          addList = this.tableList.reduce((arr, item) => {
            if (!addIds.includes(item.OrderProductId)) arr.push({ ...item, T: 0 });
            return arr;
          }, []);

          let updateList = this.data.Products.filter((i) => i.T == 1);

          addList.forEach((item) => {
            item.ColorId = item.ColorId ? item.ColorId : 0;
          });
          delList.forEach((item) => {
            item.ColorId = item.ColorId ? item.ColorId : 0;
          });
          updateList.forEach((item) => {
            item.ColorId = item.ColorId ? item.ColorId : 0;
          });
          this.data.Products = [...addList, ...delList, ...updateList];
        } else {
          this.data.Products = this.tableList;
        }

        this.data.Products.forEach((item) => {
          item.ColorId = item.ColorId ? item.ColorId : 0;
          if(item.Amount == 0 && item.Price > 0 && item.PurchaseQuantity > 0 && item.Discount > 0) {
            item.Amount = Number((item.Price * item.PurchaseQuantity * item.Discount / 100).toFixed(2));
          }
        });
        this.data.DeliveryDate = this.data.DocDate;
        if (this.data.RemainAmount == null) this.data.RemainAmount = 0;

        this.data.Pays = this.data.Pays.filter(
          (i) => (i.T || i.T == 0) && i.SettleId
        );
        console.log(this.data.Pays, "========");
        this.data.TaxPrice = Number(this.data.TaxPrice);
        console.log("保存前", this.data);
        // var data = this.$commonJs.obj.removeNullKey(this.data);
        // this.data.Requirement = "";
        const sub = JSON.parse(JSON.stringify(this.data));
        // 等于空设置为0
        sub.Products.forEach((item) => {
          Object.keys(item).forEach((key) => {
            if (
              item[key] == null &&
              key !== "LineAbortDate" &&
              key !== "DeliveryDate" && key!=="BatchStartDate"&&key!=="BatchNumber"
            ) {
              item[key] = 0;
            }
          });
        });
        this.api
          .save(sub)
          .then((res) => {
            if (res.Code === 0) {
              const id = res.Data === 0 ? this.data.OrderId : res.Data;
              this.isSave = true;
              this.is_orderUpdateStatus = false;
              this.deleteDateList = [];
              this.editOrder(id, type);
              if (type !== 1) {
                this.$message.success("保存成功");
              }
            } else {
              this.tableList = TableList;
              this.ProductModels = Product;
              this.data.Products = Product;
              this.$message.error(res.Msg);
            }
          })
          .catch((err) => {
            this.tableList = TableList;
            this.ProductModels = Product;
            this.data.Products = Product;
          });
      });
    },
    addList() {
      this.tableList.push({
        T: 0,
        OrderProductId: 0,
        // OrderId: 0,
        ColorId: null,
        ColorName: "",
        BarCode: "",
        ExistQuantity: null,
        ProductId: 0,
        Offer: null,
        Discount: 100,
        NoTaxPrice: null,
        TaxRate: null,
        Price: null,
        BatchNo: "",
        NoTaxAmount: null,
        TaxAmount: null,
        Amount: null,
        PackQuantity: null,
        InQuantity: null,
        UnitId2: 0,
        Quantity2: null,
        LineAbortEmpId: 0,
        LineAbortDate: "",
        LineAbort: 0,
        IsGift: false,
        LineAbortEmpName: "",
        UnitName: "",
        Unit2Name: "",
        SourceType: 0,
        SourceOrderId: 0,
        SourceDtsId: 0,

        SourceTypeName: "",
        PuUnitId: 0,
        PurchaseQuantity: null,
        DeliveryDate: "",
        Rate: null,
        DiscountAmount: null,
        ProductNo: "",
        ProductSpec: "",
        ProductName: "",
        ExecutionQuantity: null,
        ExecutionQuantity2: null,
        PriceType: "",
        SourceType: 0,
        SourceDocNo: "",
        StockQuantity: null,
        ExistQuantity: null,
        Remark: "",
      });

      console.log("this.tableList", this.tableList);
    },
     /** 打开批号弹框 */
    onOpenBatch(e, row, index) {
      this.batchPageParams.pageIndex = 1;
      let o = {
        IsInOut:0,
        WarehouseId:row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId:row.PropertyId,
        ColorId:row.colorId,
        pageIndex: 1,
        pageSize: 7,
      } 
      var params = this.$commonJs.obj.removeNullKey(o);
      this.pdApi.productBatchNumberList(params).then((res) => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item=>{
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          });
          this.batchListTotal = res.Count;
        }else {
          this.$message.error(res.Msg);
        }
      });
    },
      /** 选择批号 */
    onSelBatch(e, row, index){
      if (row.T !== 0) {
        row.T = 1
      }
      if(e.BatchNumber !== row.BatchNumber){
        this.tableList[index].BatchNumber = e.BatchNumber
      }
      console.log(this.tableList);
    },
    /** 输入批号 */
    inputTextBatch(text, row) {
      if (row.T !== 0) {
        row.T = 1
      }
      row.BatchNumber = text;
      //IsInOut 入库-0 出库-1
      let o = {
        IsInOut:0,
        WarehouseId:row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId:row.PropertyId,
        ColorId:row.colorId,
        BatchNumber:row.BatchNumber,
        pageIndex: 1,
        pageSize: 7,
      } 
      var params = this.$commonJs.obj.removeNullKey(o);
      this.pdApi.productBatchNumberList(params).then((res) => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item=>{
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          });
          this.batchListTotal = res.Count;
        }else {
          this.$message.error(res.Msg);
        }
      });
    },
    /** 批号下一页 */
    currentPageBatch({ val, text1 }, row) {
      this.batchPageParams.pageIndex = val;
      let o = {
        IsInOut:0,
        WarehouseId:row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId:row.PropertyId,
        ColorId:row.colorId,
        ProductName:row.ProductName,
        pageIndex: val,
        pageSize: 7,
      } 
      var params = this.$commonJs.obj.removeNullKey(o);
      this.pdApi.productBatchNumberList(params).then((res) => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item=>{
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          });
          this.batchListTotal = res.Count;
        }else {
          this.$message.error(res.Msg);
        }
      });
    },
    /** 批号起始日期 */
    changeBatchStartDate(row){
      if (row.T !== 0) {
        row.T = 1
      }
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/ .navbar-group {
  margin-bottom: 20px;

  .el-button {
    margin-left: 4px;
  }
}

.not-edit {
  display: inline-block;
  min-width: 190px;
  text-align: center;
  // border-bottom: 1px solid #e4e7ed;
}

.dropdown-item {
  padding: 5px 10px;
}

// /deep/ .tableList .el-select .el-input__inner {
//   margin-top: 10px;
//   border: none;
//   border-bottom: 1px solid #e4e7ed;
// }
</style>
